import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topicCategories } from "@/mocks/topics";

const categoryMeta: Record<string, { icon: string; count: string }> = {
  all: { icon: "ri-fire-line", count: "12846" },
  star: { icon: "ri-star-smile-line", count: "2864" },
  variety: { icon: "ri-mic-line", count: "1937" },
  screen: { icon: "ri-clapperboard-line", count: "1642" },
  storm: { icon: "ri-flashlight-line", count: "2418" },
  brand: { icon: "ri-store-2-line", count: "1085" },
  esports: { icon: "ri-gamepad-line", count: "1263" },
  music: { icon: "ri-music-2-line", count: "887" },
};

export default function Categories() {
  const list = topicCategories.filter((item) => item.id !== "all");

  return (
    <section id="categories" className="border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <SectionHeading
          eyebrow="TOPIC MAP"
          title="话题分类：按风向找到你关心的那口瓜"
          description="我们把正在扩散的话题拆成八个方向。每个方向下都会持续更新最新上榜的话题与它的扩散进度。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((category, index) => {
            const meta = categoryMeta[category.id];
            const featured = index === 0;
            return (
              <Link
                key={category.id}
                to={`/ranking?c=${category.id}`}
                className={`group flex flex-col justify-between rounded-lg border p-5 transition-colors ${
                  featured
                    ? "border-primary-300 bg-primary-50 hover:bg-primary-100"
                    : "border-background-200 bg-background-50 hover:border-primary-300"
                }`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${
                      featured ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    <i className={`${meta.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-sm text-foreground-400">
                    {meta.count}
                    <span className="ml-0.5 text-xs">条</span>
                  </span>
                </div>
                <div className="mt-6">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {category.name}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                    {category.desc}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    进入分类
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}